// 门店结款状态
export const remitStatusColor = {
  "1": "rgba(128, 128, 255, 1)",
  "2": "rgba(217, 0, 27, 1)",
  "3": "rgba(129, 211, 248, 1)",
  "4": "rgba(250, 205, 145, 1)",
  "5": "rgba(196, 198, 77, 1)",
  "6": "rgba(170, 170, 170, 1)",
  "7": "rgba(255, 109, 109, 1)"
};

export const shopStatus = {
  "1": "打款成功",
  "2": "打款失败",
  "3": "待打款",
  "4": "审核中",
  "5": "未出账",
  "6": "已冻结",
  "7": "待上传发票"
};

export const year = [

  {
    value: 2020,
    text: "2020年"
  },
  {
    value: 2021,
    text: "2021年"
  },
  {
    value: 2022,
    text: "2022年"
  },
  {
    value: 2023,
    text: "2023年"
  },
  {
    value: 2024,
    text: "2024年"
  }
];



// WEBPACK FOOTER //
// ./src/commons/enmu.js